<template>
  <figure>
    <object :data="getSource(attributes.value)" type="image/svg+xml" :style="figureStyle">{{alt}}</object>
    <figcaption v-if="attributes.caption" v-markdown="attributes.caption" :style="{maxWidth}">Fig1. - A view of the pulpit rock in Norway.</figcaption>
  </figure>
</template>

<script>
export default {
  props: ['attributes'],
  data () {
    return {
      initHeight: this.$window.innerHeight
    }
  },
  computed: {
    alt () {
      const {alt, caption} = this.attributes
      return alt || caption || 'image'
    },
    figureStyle () {
      const isImmersive = this.attributes.align && this.attributes.align === 'immersive'
      const height = isImmersive && this.isTabletWidth
                   ? this.initHeight + 'px'
                   : 'auto'

      const maxWidth = this.maxWidth
      return {height, maxWidth}
    },
    maxWidth () {
      const {maxwidth} = this.attributes
      return maxwidth || 'auto'
    },
    isTabletWidth () {
      return this.$window.innerWidth < 768
    },
    hasDesktopSource () {
      const {hasdesktop} = this.attributes
      return !hasdesktop || hasdesktop !== 'false'
    }
  },
  methods: {
    getSource (value) {
      if (!value) return null
      const {isTabletWidth, hasDesktopSource} = this
      var path = value
      if (!isTabletWidth && hasDesktopSource) {
        var [name, ext] = value.split('.')
        path = name + '-desktop.' + ext
      }
      return require(`images/${path}`)
    }
  }
}
</script>
<style lang="scss">
.immersive {
  figure img {
    object-fit: cover;
    max-width: 100%;
    width: auto;

    @include breakpoint($d_medium) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
